export class DataAfterCloseDeleteSynopticModal {

    successDelete: boolean;

    constructor() {
    }
}
